import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { StringParam, useQueryParam } from 'use-query-params';
import { Typography } from '@mui/material';

import { LMSPlatformSelector } from './LMSPlatformSelector';
import NewWPIntegration from './NewWPIntegration';
import NewMentorkitLMSIntegration from './NewMentorkitLMSIntegration';
import AddSynthesiaIntegration from './AddSynthesiaIntegration';

export type Platform = 'wordpress' | 'mentorkitLMS' | 'synthesia';
export const PLATFORMS = ['wordpress', 'mentorkitLMS', 'synthesia'] as const;
export function isPlatform(x: string): x is Platform {
  return (PLATFORMS as readonly string[]).includes(x);
}

interface IntegrationComponentProps {
  ownerID: number;
  loadingOwnerID: boolean;
}

export default function AddNewIntegration({ ownerID, loadingOwnerID }: IntegrationComponentProps) {
  const theme = useTheme();
  const [platform, setPlatform] = useQueryParam('platform', StringParam);

  const onPlatformChange = (aNewPlatform: Platform) => {
    if (aNewPlatform === platform) {
      return;
    }
    setPlatform(aNewPlatform);
  };

  useEffect(() => {
    if (platform === undefined || platform === '') {
      setPlatform('wordpress');
    }
    return () => {
      setPlatform(undefined);
    };
  }, []);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignContent: 'flex-start', flexDirection: 'column', gap: theme.spacing(4) }}>
      <div style={{ overflow: 'auto', background: theme.palette.bgTwo.main, display: 'flex', width: '100%' }}>
        <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: theme.spacing(2), gap: theme.spacing(2) }}>
          <div>
            <Typography variant='h6'>Add New Integration</Typography>

            <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(3) }}>
              <LMSPlatformSelector value={platform} onChange={onPlatformChange} />
              {platform === 'wordpress' && <NewWPIntegration ownerID={ownerID} loadingOwnerID={loadingOwnerID} />}
              {platform === 'mentorkitLMS' && <NewMentorkitLMSIntegration ownerID={ownerID} loadingOwnerID={loadingOwnerID} />}
              {platform === 'synthesia' && <AddSynthesiaIntegration ownerID={ownerID} loadingOwnerID={loadingOwnerID} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
